import React, { useMemo } from 'react'
import { useTbViewStore, useProjectStore, useAppEx } from '@vt/hooks'
import { pick, flatten, get } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import { Button, Modal } from '@ow/comps'
import { useDataOperateStore } from '../data-operate/data-operate-store-provider'
import { showSimilarUcase } from './SimilarUcase'
import { showDetail } from '../details-copy'

const downloadFile = function (url) {
  const iframe = document.createElement('a')
  iframe.style.display = 'none'
  iframe.style.height = 0
  iframe.style.pointerEvents = 'none'
  iframe.href = url
  document.body.appendChild(iframe)
  iframe.click()
  setTimeout(() => {
    iframe.remove()
  }, 5 * 60 * 1000)
}

const maps = {
  similarUcaseConfig: '相似案件',
  logConfig: '查看日志',
  detailConfig: '详情',
  editorConfig: '编辑',
  recoveryConfig: '恢复',
  deleteConfig: '删除',
  downloadConfig: '下载文件',
}

const Operate = function (props) {
  const { payload, value = {}, rowIndex } = props

  const { rowData, defs } = value
  const { userInfoInApp } = useAppEx((state) => pick(state, ['userInfoInApp']))

  const {
    showRecycle,
    operatorConfig,
    editorConfig,
    recycleConfig,
    destroyTbData,
    recoverTbData,
    setRefreshStatus,
  } = useTbViewStore((state) =>
    pick(state, [
      'showRecycle',
      'editorConfig',
      'operatorConfig',
      'recycleConfig',
      'destroyTbData',
      'recoverTbData',
      'setRefreshStatus',
    ])
  )

  const customCompsMap = useProjectStore((state) => state.customCompsMap)
  const { operators } = useDataOperateStore((state) =>
    pick(state, ['operators'])
  )
  const { showCreate, showTbDetail } = operators || {}

  const { OperateComponent } = customCompsMap || {}

  // const showCurrentDataDetail = (_data) => {
  //   showDetail({ currentData: _data })
  // }

  const onShowSimilarUcase = (data) => {
    showSimilarUcase(data)
  }

  // 针对当前rowData允许的操作项
  const operatorsAllowed = useMemo(() => {
    const currentOperatorConfig = showRecycle
      ? operatorConfig.recycle
      : operatorConfig.operatorConfig
    const { allow, allowType } = editorConfig || {}

    if (!showRecycle) {
      const opts = get(currentOperatorConfig, 'elements', []).map((item) => {
        // 先只判断了编辑
        if (item.actionType === 'editorConfig') {
          if (
            rowData &&
            rowData.createdBy &&
            allow &&
            allowType === 'createBySelf' &&
            userInfoInApp.id === rowData.createdBy.id
          ) {
            return item
          }
          if (allowType !== 'createBySelf') {
            return item
          }
          return null
        }
        return item
      })

      return opts.filter((v) => v)
    }

    return (currentOperatorConfig && currentOperatorConfig.elements) || []
  }, [showRecycle, rowData])

  if (!operatorsAllowed.length) {
    return null
  }

  const footer = ({ close, data, payload: _payload }) => {
    const { objectId } = _payload || {}
    return (
      <div className="flex justify-center items-center gap-2">
        <Button stroke onClick={close}>
          取消
        </Button>
        <Button
          type="primary"
          onClick={() => {
            destroyTbData([objectId || data.objectId]).then(() => {
              setRefreshStatus(true)
              showNotification({
                title: '删除成功',
              })
            })
          }}
        >
          确认
        </Button>
      </div>
    )
  }

  const deleteRender = (trigger) => {
    return (
      <Modal
        trigger={trigger}
        showCloseButton
        size="sm"
        title="提示"
        footer={({ close }) =>
          footer({
            close,
            data: rowData,
            payload,
          })
        }
      >
        <div className="text-white-400" style={{ fontSize: '14px' }}>
          <div>
            {recycleConfig && recycleConfig.allow
              ? '删除后记录将被移至回收站，您可以在回收站中恢复记录。'
              : '删除后无法恢复、是否确定删除？'}
          </div>
        </div>
      </Modal>
    )
  }

  const DefaultComponent = (
    <div className="w-full h-full flex flex-row gap-6">
      {(operatorsAllowed || []).map((opt) => {
        switch (opt.actionType) {
          case 'copy-collector':
            return (
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  color: 'var(--ow-color-primary-700)',
                  fontSize: '14px',
                }}
                onClick={() => {
                  showCreate(rowData, null, null, {
                    optType: 'duplicate',
                    title: '复制案件',
                  })
                }}
              >
                复制案件
              </div>
            )
          case 'detailConfig':
            return (
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  color: 'var(--ow-color-primary-700)',
                  fontSize: '14px',
                }}
                onClick={() => {
                  showDetail({ currentData: rowData })
                }}
              >
                {maps[opt.actionType]}
              </div>
            )
          case 'similarUcaseConfig':
            return (
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  color: 'var(--ow-color-primary-700)',
                  fontSize: '14px',
                }}
                onClick={() => {
                  onShowSimilarUcase(rowData)
                }}
              >
                {maps[opt.actionType]}
              </div>
            )
          case 'editorConfig':
            return (
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  color: 'var(--ow-color-primary-700)',
                  fontSize: '14px',
                }}
                onClick={() => {
                  showCreate(rowData)
                }}
              >
                {maps[opt.actionType]}
              </div>
            )
          case 'batchEditorConfig':
            return (
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  color: 'var(--ow-color-primary-700)',
                  fontSize: '14px',
                }}
                onClick={() => {
                  showCreate(rowData, {}, true)
                }}
              >
                {maps[opt.actionType]}
              </div>
            )
          case 'recoveryConfig':
            return (
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  color: 'var(--ow-color-primary-700)',
                  fontSize: '14px',
                }}
                onClick={() => {
                  recoverTbData(rowData.objectId).then(() => {
                    setRefreshStatus(true)
                    showNotification({
                      title: '操作成功',
                    })
                  })
                }}
              >
                {maps[opt.actionType]}
              </div>
            )
          case 'deleteConfig':
            return deleteRender(
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  fontSize: '14px',
                  color: 'var(--ow-color-error-500)',
                }}
              >
                {maps[opt.actionType]}
              </div>
            )
          case 'downloadConfig':
            return (
              <div
                className="flex justify-center items-center cursor-pointer"
                key={`operate-defalut-component-${opt.actionType}`}
                style={{
                  color: 'var(--ow-color-primary-700)',
                  fontSize: '14px',
                }}
                onClick={() => {
                  if (opt.slugs && opt.slugs.length) {
                    const arr = flatten(
                      opt.slugs.map((v) => {
                        return rowData[v]
                      })
                    ).filter((v) => v)
                    arr.forEach((v) => {
                      const endPosition = v.src.indexOf('?Expires=')

                      downloadFile(
                        `${
                          endPosition === -1
                            ? v.src
                            : v.src.slice(0, endPosition)
                        }`
                      )
                    })
                  }
                }}
              >
                {maps[opt.actionType]}
              </div>
            )
          default:
            return null
        }
      })}
    </div>
  )

  if (OperateComponent && !showRecycle) {
    return (
      <OperateComponent
        rowIndex={rowIndex}
        rowData={rowData}
        defs={defs}
        onClickOpenDetail={showTbDetail}
        onClickUpdateData={showCreate}
        onClickDestroyData={() => {
          destroyTbData([rowData.objectId])
        }}
      >
        {operatorsAllowed && operatorsAllowed.length ? DefaultComponent : null}
      </OperateComponent>
    )
  }

  return DefaultComponent
}
export default Operate
